module.exports = __webpack_public_path__ + "img/refresh.6043fc94.png";